// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__MEN--","FooterLink":"Footer_FooterLink__g7IjA","IconGrid":"Footer_IconGrid__pkhaG","ContainerGrid":"Footer_ContainerGrid__nlvat"};